import React, { useState, useEffect } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import { LocationsSelectInput, EquipmentsSelectInput, Select, FiltersContainer } from '../../../../components'
import { setPayload } from '../../helpers'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import { filtersStyles as styles } from '../../../../components/FiltersContainer/styles'

const Filters = ({
  initialValues, modalRef, onClose, handleSearch, handleClearFilters, handleSearchOrderNumber
}) => {
  const { isTablet } = usePlatforms()
  const [filters, setFilters] = useState({})

  useEffect(() => {
    setFilters(initialValues)
  }, [initialValues])

  const handleSetFilters = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }))
  }

  const handleOnPress = () => {
    const body = setPayload(filters)
    if (!Object.keys(body).length) return
    handleSearch(filters)
    onClose()
  }
  return (
    <FiltersContainer
      modalRef={modalRef}
      onClose={onClose}
      handleSearch={handleOnPress}
      handleClearFilters={handleClearFilters}
      initOrderNumber={initialValues.movementNumber}
      orderNumberFilter
      handleSearchOrderNumber={handleSearchOrderNumber}
    >
      <View style={[isTablet && styles.inputsContainer]}>
        <View style={[styles.input, isTablet && styles.inputTablet]}>
          <LocationsSelectInput
            name='originState'
            placeholder='Origin'
            origin
            selected={filters.originState}
            onChange={handleSetFilters}
          />
        </View>
        <View style={[styles.input, isTablet && styles.inputTablet]}>
          <LocationsSelectInput
            name='destState'
            placeholder='Destination'
            selected={filters.destState}
            onChange={handleSetFilters}
          />
        </View>
        <View style={[styles.input, isTablet && styles.inputTablet]}>
          <EquipmentsSelectInput
            name='equipmentType'
            selected={filters.equipmentType}
            onChange={handleSetFilters}
          />
        </View>
        <View style={[styles.input, isTablet && styles.inputTablet]}>
          <Select
            name='daysFromToday'
            selected={filters.daysFromToday}
            onChange={handleSetFilters}
            placeholder='Days to view'
            keyProp='value'
            nameProp='label'
            options={[
              { value: '0', label: 'Today' },
              { value: '7', label: '7 days' },
              { value: '15', label: '15 days' },
              { value: '30', label: '1 month' },
              { value: '60', label: '2 months' },
              { value: '90', label: '3 months' }
            ]}
          />
        </View>
      </View>
    </FiltersContainer>
  )
}

Filters.propTypes = {
  initialValues: PropTypes.object.isRequired,
  modalRef: PropTypes.any.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleClearFilters: PropTypes.func,
  handleSearchOrderNumber: PropTypes.func
}

export default Filters
